import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

const SvgElement = styled('svg', { label: 'SvgElement' })`
    height: auto;
`;

interface PropsType {
    className?: string;
    onClick?: () => void;
}

export const BresbetBrandIcon = observer(
    'BresbetBrandIcon',
    ({ className, onClick }: PropsType): JSX.Element => (
        <SvgElement
            className={className}
            onClick={onClick}
            fill='none'
            width='28'
            height='15'
            viewBox='0 0 28 15'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g>
                <path
                    d='M0.666626 0.333344H7.21107C11.1444 0.333344 12.8333 1.47779 12.8333 3.97779C12.8333 5.87779 11.7333 6.91112 9.71107 7.35557V7.56668C12.4444 7.80001 13.3333 8.63334 13.3333 10.6889C13.3333 13.0667 11.8111 14.6222 7.87774 14.6222H0.666626V0.333344ZM4.95551 3.52223V6.1889H7.1444C8.31107 6.1889 8.76662 5.83334 8.76662 4.83334C8.76662 3.90001 8.36663 3.52223 7.22218 3.52223H4.95551ZM4.95551 9.02223V11.5222H7.7444C8.67774 11.5222 9.09996 11.0445 9.09996 10.2889C9.09996 9.43334 8.81107 9.02223 7.66663 9.02223H4.95551Z'
                    fill='#ED3FAA'
                />
                <path
                    d='M14.6666 0.333344H21.2111C25.1444 0.333344 26.8333 1.47779 26.8333 3.97779C26.8333 5.87779 25.7333 6.91112 23.7111 7.35557V7.56668C26.4444 7.80001 27.3333 8.63334 27.3333 10.6889C27.3333 13.0667 25.8111 14.6222 21.8777 14.6222H14.6666V0.333344ZM18.9555 3.52223V6.1889H21.1444C22.3111 6.1889 22.7666 5.83334 22.7666 4.83334C22.7666 3.90001 22.3666 3.52223 21.2222 3.52223H18.9555ZM18.9555 9.02223V11.5222H21.7444C22.6777 11.5222 23.1 11.0445 23.1 10.2889C23.1 9.43334 22.8111 9.02223 21.6666 9.02223H18.9555Z'
                    fill='#ED3FAA'
                />
            </g>
        </SvgElement>
    )
);
